import styled from 'styled-components';
import { theme, toRem } from 'design';

const ModalHeader = styled.header`
  position: relative;
  z-index: ${theme.zIndex.modal + 3};
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: ${toRem(theme.space.sm)} 0;
  background-color: ${theme.color.white};
  text-align: center;
`;

export default ModalHeader;
